import { cn } from '@/utils/styles/cn'
import { IChildrenProps } from '@/utils/typings/children-props'
import { IClassNameProps } from '@/utils/typings/class-name-props'

type IStepContainerProps = IChildrenProps & IClassNameProps

/**
 * Container for onboarding/auth steps.
 * Default min-width is 400px on desktop (md+), full width on mobile.
 * Override with className like `md:min-w-[450px]` for custom widths.
 *
 * Handles fade-in animation via CSS (tailwindcss-animate) rather than a JS-driven
 * mount animation. The CSS animation always reaches its end state, so the content
 * can never get stuck at opacity 0 — which previously happened when this mounted
 * during a busy frame (e.g. the invite-accept redirect), leaving an empty modal.
 */
export const StepContainer = ({ children, className }: IStepContainerProps) => {
    return (
        <div className={cn('flex flex-col gap-3 w-full md:min-w-[320px] animate-in fade-in-0 duration-200', className)}>
            {children}
        </div>
    )
}
